import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { handlAuthUserType } from '../../../reducersAndActions/actions/authAction';
import { useAuth } from '../../../contexts/auth';
import DatePickerTickets from '../../Tickets/DatePickerTickets';
import { getContractTypeVal, getProjectId } from '../../../lib/common';
import styles from './Header.module.scss';

function DateFilterHeader({ setEndDate, setStartDate, _state, _setState, getTicketsData }) {
  const navigate = useNavigate();
  const [authState, dispatch] = useAuth();
  const { type } = authState;
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const loginType = searchParams.get('type');
  const [isTooltip, setTooltip] = useState(true);
  const [isDatePicker, setIsDatePicker] = useState(false);
  const pageType = location.pathname.replace('/csportal', '').replace('/', '') || '';
  const projectId = getProjectId();
  const contractVal = getContractTypeVal(projectId);

  const handleGoBack = () => {
    if (loginType) {
      const newUrl = location.pathname;
      handlAuthUserType(dispatch, '');
      navigate(newUrl, { replace: true });
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setTooltip(false);
    }, 3000);
  }, []);

  return (
    <>
      <header className={`${styles.header_box} ${styles.header_blue} `}>
        <div className={`${styles.header_left}`}>
          <div
            aria-label="header_back_btn"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            className={`csicon ${styles.page_whiteback_icon} `}
            id="headerback"
            onClick={() => handleGoBack()}
          />
        </div>
        <div className={`${styles.header_center}`}>
          <div className={`${styles.header_text} text_center`}>
            {type === 'business' || pageType === 'myTickets' || projectId === 'genio' ? (
              <div className="csheader_text text_center">
                <div className="font14 fw600 colorFFF">
                  <div>My Tickets</div>
                </div>
              </div>
            ) : (
              <div className="font14 fw600 colorFFF text-center">Customer Support</div>
            )}
          </div>
        </div>
        {(projectId === 'genio' || (projectId === 'csportal' && authState?.sidResponse && contractVal !== 'free')) && (
          <div className={`${styles.header_right}`}>
            <div
              aria-label="date_filter"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className={`csicon ${styles.threeots_icon}`}
              style={{
                width: '30px',
                height: '30px',
                backgroundSize: '24px',
                cursor: 'pointer',
                transitionProperty: 'background-color, background-image, broder-color, box-shadow',
                transition: 'all 0.8s',
                borderRadius: '100%',
                transform: 'scale(1)',
              }}
              onClick={() => setIsDatePicker(true)}
            />
            {isTooltip && (
              <div className={`${styles.tooltip_header} toolDate`}>
                <div className="font12 fw400 colorFFF">Date Filter</div>
              </div>
            )}
          </div>
        )}
      </header>
      {isDatePicker && (
        <DatePickerTickets
          openPopup={isDatePicker}
          handleClose={() => setIsDatePicker(false)}
          getTicketsData={getTicketsData}
          setEndDate={setEndDate}
          setStartDate={setStartDate}
          _state={_state}
          _setState={_setState}
        />
      )}
    </>
  );
}

export default DateFilterHeader;

DateFilterHeader.propTypes = {
  setEndDate: PropTypes.func,
  setStartDate: PropTypes.func,
  _state: PropTypes.object,
  _setState: PropTypes.func,
  getTicketsData: PropTypes.func,
};
